export default function removeSpaces(str) {
  if (!str || typeof str !== 'string') return '';

  return !!str && str.replace(/\s/g, '').trim();
}
